export default "__VITE_ASSET__5e9da96d__"